import React from 'react';
import {
  Button,
  CssBaseline,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  Container,
  IconButton,
  Input,
  InputLabel,
  InputAdornment,
  FormControl,
  Grow,
  FormHelperText,
  Theme,
  Card,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Alert } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import clsx from 'clsx';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Loader from '../../utils/Loader';
import Alerts from '../AlertMessage/AlertMessage';
import { signInValidate } from './validate';
import { getUserParams, getOSVersion } from '../../helpers/browser';
import { history } from '../../utils/history';
import Error from '../AlertMessage/ErrorPage';
import logo from '../../media/logo3.png';
const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    // marginTop: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(0),
    marginLeft: 0,
  },
  submit: {
    margin: theme.spacing(3, 0, 3),
  },
  padding: {
    padding: theme.spacing(2, 0, 0, 0),
  },
  headerText: {
    paddingTop: '20px',
    paddingBottom: '5px',
    marginBottom: '20px',
    borderBottom: `solid 2px ${theme.palette.secondary.main} !important`,
    textAlign: 'center',
  },
  links: {
    paddingRight: '10px',
    paddingLeft: '10px',
    fontSize: '14px',
  },
}));
export interface Props {
  handleChange: (userName: string) => void;
  onCheck: (checked: boolean) => void;
  signIn: (username: string, password: string, checked: boolean) => void;
  checked: boolean;
}

function SignIn(props: any) {
  const classes = useStyles();
  const { user } = props;
  useTranslation();
  const [errors, setErrors] = React.useState<any>({});
  let username = localStorage.getItem('username');
  let path = localStorage.getItem('path');

  const [values, setValues] = React.useState({
    userName: 'test@test.com',
    password: '1234',
    remember: username ? true : false,
    showPassword: false,
    requestIp: null,
    userAgent: getOSVersion(window),
  });
  const params: any = window.location.pathname.split('/')[1];
  const [checked, setChecked] = React.useState(username ? true : false);

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };
  const handleChange =
    (prop: any) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
    };

  const onCheck = () => {
    checked ? setChecked(false) : setChecked(true);
    setValues({ ...values, remember: !checked });
  };
  const signIn = (e: any) => {
    e.preventDefault();
    let valid;
    valid = signInValidate(values, setErrors);
    if (valid) {
      storeUsername(values.userName, values.remember);
      props.onSignIn();
      history.push(`/memberfitness/profile`);
    }
  };

  const storeUsername = (username: string, remember?: boolean) => {
    if (remember) {
      try {
        localStorage.setItem('username', username);
      } catch (e) {
        window.console.error(e);
      }
    } else {
      try {
        localStorage.removeItem('username');
      } catch (e) {
        window.console.error(e);
      }
    }
  };
  return (
    <div
      style={{
        position: 'relative',
        height: '90vh',
      }}
    >
      <CssBaseline />
      <Container
        maxWidth="xs"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Card raised sx={{ p: 2, backgroundColor: '#252525' }}>
          <div className={classes.paper}>
            <img src={logo} width={240} alt="logo" />
            <Grow in={true} timeout={150}>
              <Typography
                className={classes.headerText}
                component="h3"
                variant="h5"
                color="primary.contrastText"
              >
                <Trans>SIGN IN</Trans>
              </Typography>
            </Grow>
            <Grow in={true} timeout={250}>
              <Typography
                color="primary.contrastText"
                style={{ fontSize: 16 }}
                component="h2"
                variant="h5"
              >
                <Trans>SIGN IN TO MEMBER FITNESS</Trans>
              </Typography>
            </Grow>

            <form id="signin-form" className={classes.form} noValidate>
              <input type="hidden" value="something" />
              {!props.requesting ? (
                <div>
                  <Grow in={true} timeout={350}>
                    <TextField
                      margin="normal"
                      variant="standard"
                      fullWidth
                      aria-label="userName"
                      id="userName"
                      data-testid="userName"
                      autoComplete="userName"
                      label={<Trans>Username</Trans>}
                      name="userName"
                      onChange={handleChange('userName')}
                      autoFocus
                      color="secondary"
                      inputProps={{
                        style: {
                          color: 'white',
                          backgroundColor: '#252525',
                          borderRadius: 4,
                        },
                      }}
                      value={values.userName}
                      error={errors.userName ? true : false}
                      helperText={errors.userName}
                    />
                  </Grow>
                  <Grow in={true} timeout={500}>
                    <FormControl
                      color="secondary"
                      className={clsx(classes.form)}
                    >
                      <InputLabel
                        style={{
                          marginBottom: 10,
                          marginLeft: -13,
                          marginTop: 8,
                        }}
                        htmlFor="standard-adornment-password"
                        error={errors.password ? true : false}
                      >
                        Password
                      </InputLabel>
                      <Input
                        autoComplete="new-password"
                        id="standard-adornment-password"
                        name="password"
                        color="secondary"
                        type={values.showPassword ? 'text' : 'password'}
                        value={values.password}
                        onChange={handleChange('password')}
                        error={errors.password ? true : false}
                        inputProps={{
                          'data-testid': 'password',
                          style: { marginBottom: 5, color: 'white' },
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              size="large"
                              sx={{ color: 'white' }}
                            >
                              {values.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      <FormHelperText
                        sx={{ ml: 0 }}
                        error={errors.password ? true : false}
                      >
                        {errors.password}
                      </FormHelperText>
                    </FormControl>
                  </Grow>
                  <Grow in={true} timeout={750}>
                    <FormControlLabel
                      color="secondary"
                      control={
                        <Checkbox
                          onChange={onCheck}
                          data-testid="remember"
                          checked={values.remember}
                          color="secondary"
                        />
                      }
                      label={
                        <span style={{ fontSize: '14px', color: 'white' }}>
                          Remember Me
                        </span>
                      }
                    />
                  </Grow>
                </div>
              ) : (
                <Loader messages={props.messages} />
              )}
              <Grow in={true} timeout={1000}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="secondary"
                  className={classes.submit}
                  onClick={signIn}
                >
                  <Trans>SIGN IN</Trans>
                </Button>
              </Grow>
            </form>
          </div>
        </Card>
      </Container>
    </div>
  );
}

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSignIn: (config: any) => dispatch({ type: 'FAKE_LOGIN' }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
